import REGEX from './regex';
import OPTION from './option';

export default {
  REGEX,
  OPTION,
};
